module.exports = __webpack_public_path__ + "media/promo/panasonic/images/recipes/rec-1-min-aa11dac2d2e97a64547c8adcd773fb5e.jpg";